
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import Form4ProcessHeader from "@/components/process/Form4/components/Form4ProcessHeader.vue";
import Form4 from "@/components/process/Form4/components/pdf/Form4.vue"

import { form4StatusInfoType } from '@/types/Information/Form4';

@Component({
    components:{
        Form4ProcessHeader,
        Form4
    }
})
export default class PreviewForm4 extends Vue {

    @form4State.State
    public currentNoticeOfSettlementOrAbandonmentId: string;

    stepsCompleted = {} as form4StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form4"}); 
    }
}
